// extracted by mini-css-extract-plugin
module.exports = {"ReturnsHeader":"styles_ReturnsHeader__GI_7h"};